import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'options-control',

  props: [
    'quiz',
  ],

  data() {
    return {
      selectedOption: null,
      startTime: new Date(),
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      cardId: 'getCardId',
      isEnd: 'getIsEnd',
      quizSolved: 'getQuizSolved',
      quizResult: 'getQuizResult',
      preselectedOption: 'getPreselectedOption',
      isClassStudent: 'isClassStudent',
      pagination: 'getPagesPagination',
    }),
  },

  methods: {
    ...mapActions({
      selectQuiz: 'selectQuiz',
      saveQuizOption: 'saveQuizOption',
    }),

    goNextPage() {
      if (this.pagination.page < this.pagination.total) {
        this.$router.push({ name: 'pages.show', params: { page: this.pagination.page + 1 } });
      }
      if (this.pagination.page === this.pagination.total && !this.isEnd) {
        this.$router.push({ name: 'pages.confirm_submit', params: { cardId: this.cardId } });
      }
      if (this.pagination.page === this.pagination.total && this.isEnd) {
        this.$router.push({ name: 'cards.results', params: { cardId: this.cardId } });
      }
    },

    solve(option) {
      if (!this.isClassStudent) {
        return;
      }

      if (this.quizSolved) {
        return;
      }

      this.saveQuizOption({ quiz: this.quiz, option });
      this.selectedOption = option;
    },

    getOptionsClassNames(option) {
      return {
        selected: this.isSelected(option),
        correct: this.isCorrect(option),
        incorrect: this.isIncorrect(option),
        disabled: !this.isClassStudent,
      };
    },

    isSelected(option) {
      return this.selectedOption && this.selectedOption.id === option.id && !this.quizSolved;
    },

    isCorrect(option) {
      return this.quizSolved && option.is_correct;
    },

    isIncorrect(option) {
      return this.quizSolved &&
        this.quizResult.answer_id === option.id &&
        !option.is_correct;
    },
  },

  beforeMount() {
    if (!isEmpty(this.preselectedOption)) {
      this.selectedOption = this.preselectedOption;
    }
  },

  watch: {
    $route() {
      if (!isEmpty(this.preselectedOption)) {
        this.selectedOption = this.preselectedOption;
      }
    },
  },
};
